import React, { useState } from "react";

import { addDaysInput, formatDate, isActionQuiet, toInputDate } from "./constants";

// Marks a follow-up handled without waiting on Jev. Relancé books the next look and keeps the
// red Act off until that morning. Done does the same for a week, and only moves a due date that
// would otherwise turn red again while the badge is off.
const HORIZONS = [
  { days: 3, label: "3 days" },
  { days: 7, label: "1 week" },
  { days: 14, label: "2 weeks" },
];

export default function FollowUp({ deal, onUpdate }) {
  const [picking, setPicking] = useState(false);
  const [saving, setSaving] = useState(false);

  const run = async (payload) => {
    setPicking(false);
    setSaving(true);
    try {
      await onUpdate(deal._id, payload);
    } finally {
      setSaving(false);
    }
  };

  const save = (days) => {
    const until = addDaysInput(days);
    const due = toInputDate(deal.next_action_at);
    const payload = {
      last_contact_at: addDaysInput(0),
      sales_action_quiet_until: until,
    };
    if (!due || due <= until) payload.next_action_at = until;
    run(payload);
  };

  const relance = (days) => {
    const until = addDaysInput(days);
    run({
      last_contact_at: addDaysInput(0),
      next_action_at: until,
      sales_action_quiet_until: until,
    });
  };

  if (saving) return <span className="text-[11px] text-gray-400">Saving…</span>;

  if (isActionQuiet(deal)) {
    return (
      <button
        type="button"
        title="The red Act is hidden until this date. Click to show it again."
        onClick={() => onUpdate(deal._id, { sales_action_quiet_until: null })}
        className="text-[11px] font-medium text-gray-500 hover:text-gray-800 underline decoration-gray-300">
        Off until {formatDate(deal.sales_action_quiet_until)}
      </button>
    );
  }

  if (picking) {
    return (
      <span className="inline-flex items-center gap-1">
        {HORIZONS.map((h) => (
          <button
            key={h.days}
            type="button"
            onClick={() => relance(h.days)}
            className="px-1.5 py-0.5 text-[11px] font-medium rounded border border-gray-300 bg-white text-gray-700 hover:bg-gray-50">
            {h.label}
          </button>
        ))}
        <button type="button" onClick={() => setPicking(false)} className="text-[11px] text-gray-400 hover:text-gray-700">
          Cancel
        </button>
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1">
      <button
        type="button"
        title="You followed up. Pick when to look again — the red Act stays off until then."
        onClick={() => setPicking(true)}
        className="px-1.5 py-0.5 text-[11px] font-semibold rounded border border-gray-300 bg-white text-gray-800 hover:bg-gray-50">
        Relancé
      </button>
      <button
        type="button"
        title="You did it. Hides the red Act for a week, and moves the due date if it was overdue."
        onClick={() => save(7)}
        className="px-1.5 py-0.5 text-[11px] font-medium rounded border border-gray-200 bg-white text-gray-600 hover:bg-gray-50">
        Done
      </button>
    </span>
  );
}
